export const ColumnFormat = {
  FORMAT_STRING: 'string',
  FORMAT_ID: 'id',
  FORMAT_INTEGER: 'integer',
  FORMAT_PERCENT: 'percent',
  FORMAT_CURRENCY: 'currency',
  FORMAT_RANKING: 'ranking',
  FORMAT_BOOLEAN: 'bool',
  FORMAT_DECIMAL: 'decimal',
  FORMAT_ARRAY: 'array',
  FORMAT_DATE: 'date',
  FORMAT_TIME: 'time',
  FORMAT_DATETIME: 'datetime',
  FORMAT_LINK: 'link',
  FORMAT_URL: 'url',
  FORMAT_IMAGE: 'image',
  FORMAT_CALLBACK: 'callback',
  FORMAT_COORDINATE: 'coordinate',
  FORMAT_OBJECT: 'object',
  FORMAT_PHONE_NUMBER: 'phonenumber',
  FORMAT_ENUM: 'enum',
  FORMAT_AUDIO: 'audio',
  FORMAT_THUMBNAIL: 'thumbnail',
  FORMAT_PREVIEW: 'preview',
  FORMAT_CLICK_TO_VIEW_LINK: 'clicktoview_link',
};

export const ImportWizardRoute = {
  IMPORTWIZARD: 'importwizard',
};

export const ImportWizardOperations = {
  SUM: 'sum',
  AVERAGE: 'average',
  AVERAGE_SKIP_ZEROS: 'average_skip_zeros',
  MOST_RECENT_VALUE: 'most_recent_value',
};

export const ImportWizardPathName = {
  IMPORTWIZARD: 'importwizard',
  IMPORTWIZARDFORM_NEW: 'importwizardform:new',
  IMPORTWIZARDFORM: 'importwizardform',
  IMPORTWIZARDFORM_CLONE: 'importwizardform:clone',
  IMPORTWIZARDFORM_SUB: 'importwizardform:sub',
  IMPORTWIZARDMANAGEUPLOADS: 'importwizardmanageuploads',
  IMPORTWIZARDFORM_VUE: 'importwizardformvue',
  IMPORTWIZARDFORM_VUE_NEW: 'importwizardformvue:new',
  IMPORTWIZARDFORM_VUE_CLONE: 'importwizardformvue:clone',
  IMPORTWIZARDFORM_VUE_SUB: 'importwizardformvue:sub',
  IMPORTWIZARDFORM_VUE_SUB_NEW: 'importwizardformvue:sub:new',
  IMPORTWIZARD_EMAILS: 'ImportWizardEmails',
};

export const ImportWizardSegmentEvents = {
  IMPORT_WIZARD_SAVE_EVENT: 'ImportWizardSaveEvent',
};

export const ImportWizardEvents = {
  IMPORT_WIZARD_VALIDATE_CONNECTION: 'ImportWizardValidateConnection',
  IMPORT_WIZARD_UPLOAD_SAMPLE_DATA: 'ImportWizardUploadSampleData',
  IMPORT_WIZARD_LOAD_TAPI_SAMPLE: 'ImportWizardLoadTapiSample',
};

export const ImportWizardPseudoPath = {
  SUB: '/sub/',
};

export const GoogleSheetQuery = {
  GOOGLE_SHEET_ID: 'google-sheet-id',
};

export const DefaultIcon = 'icon-bar-chart-o';

export const FileDownloadConstants = {
  RESPONSE_TYPE_BLOB: 'blob',
  FILENAME_HEADER_KEYWORD: 'filename=',
};

export const GoogleSheetDefault = {
  id: '',
  tabs: [],
  sheet_id: null,
  title: '',
  type: '',
  use_tab_name_for_mapping: null,
  exact_match: true,
  is_case_sensitive: false,
  pattern: '',
  use_regex: false,
};

export const ImportWizardConstants = {
  CHANNEL: 'channel',
  DATA_SOURCE: 'data-source',
  FILE: 'file',
  FTP: 'ftp',
  MANUAL: 'manual',
  SQL: 'sql',
  DYNAMIC: 'dynamic',
  READONLY: 'Read only', // 1
  HIDDEN: 'Hidden', // 2
  READONLY_KEY: 'Read only key', // 3
  EDITABLE: 'Editable/Visible', // 0
  SC_VIRTUAL_MAPPING: 'smart_connector_virtual_mapping',
  SC_VIRTUAL_MAPPING_LABEL: 'All Data',
  VIRTUAL_SC_NODATE: 'VIRTUAL_SC_NODATE',
  SC_TAB_MAPPING: 'smart_connector_tab_mapping',
  SC_TAB_MAPPING_LABEL: 'Tab Name',
  SC_GEO_SINGLE_COUNTRY: 'country',
  AUTH_TYPE_CATEGORY_BASIC: 'basic',
  AUTH_TYPE_CATEGORY_HOSTED_FILE: 'hosted_file',
  AUTH_TYPE_CATEGORY_DATABASE: 'database',
  AUTH_TYPE_CATEGORY_DIRECT_TO_SOURCE: 'direct_to_source',
  AUTH_TYPE_CATEGORY_OTHER: 'other',
  AUTH_TYPE_CATEGORY: {
    basic: 'Basic',
    hosted_file: 'Hosted File',
    database: 'Database',
    direct_to_source: 'Direct to Source',
    other: 'Other',
  },
  EXTRA_FORMAT_INTEGER_BIG: 'integer_big',
  EXTRA_FORMAT_STRING_ID: 'string_id',
  TIMEZONE_TYPE_CODE: 'code',
  TIMEZONE_TYPE_FIELD: 'field',
  SMART_CONNECTOR_VIRTUAL_ASSIGMENT_TEXT: 'SmartConnector Virtual Assignment',
  DATETIME: 'Datetime',
  GEO_COUNTRY_FIELD_MODE: {
    COUNTRY_IN_DATA: 'country_in_data',
    SINGLE_COUNTRY: 'single_country',
  },
  GEO_COUNTRY_FIELD_MODES: {
    country_in_data: 'Select Country field from the Data',
    single_country: 'Assign all data to a single Country Code',
  },
  COUNTRY: {
    US: 'US',
  },
  GEO_LOCATION_TYPE: {
    COUNTRY: 'country',
  },
  US_DEPENDANT_GEO_LOCATION_TYPES: [
    'state',
    'city',
    'county',
    'congressional_district',
    'zip',
    'dma',
  ],
  PREPROCESS_FUNCTION_CUSTOM_FUNCTION_VALUE: 'custom',
};

export const PreprocessFunctionsTypes = {
  CUSTOM: 'custom',
  EXTRACT_REGEX_PATTERN: 'tapBuiltIn:extractRegexPattern',
  CONVERT_TO_UTF8: 'tapBuiltIn:convertToUtf8',
  FORMAT_CSV_DATES: 'tapBuiltIn:formatCSVDates',
};

export const IMPORT_CONN_TYPE = {
  FORM_FIELDS: 'form_fields',
  MANUAL: 'manual',
  OAUTH: 'oauth',
  DYNAMIC: 'dynamic',
  LIVE_CONNECTOR: 'live_connector',
};

export const IMPORT_AUTH_TYPE = {
  ALLOYDB: 'AlloyDB',
  AMAZON_S3: 'Amazon S3',
  AMAZON_ATHENA: 'Amazon Athena',
  AMAZON_AURORA_MYSQL: 'Amazon Aurora MySQL',
  AMAZON_AURORA_PGSQL: 'Amazon Aurora PostgreSQL',
  BIGQUERY: 'Google BigQuery',
  BIGQUERY_SERVICE_ACCOUNT: 'Google BigQuery (Service Account)',
  BIGQUERY_LIVE: 'Google BigQuery (Live)',
  CLICKHOUSE: 'ClickHouse',
  BOX: 'Box',
  BRIGHT_EDGE_QL: 'BrightEdge Query Language',
  EMAIL: 'Email',
  FTP: 'FTP',
  GOOGLE_DRIVE: 'Google Drive',
  GOOGLE_CLOUD_STORAGE: 'Google Cloud Storage',
  GOOGLE_CLOUD_STORAGE_SERVICE_ACCOUNT: 'Google Cloud Storage (Service Account)',
  GOOGLE_SHEET: 'Google Sheet',
  MANUAL: 'Manual',
  GOOGLE_ANALYTICS: 'Google Analytics',
  MICROSOFTAZURESQL: 'Microsoft Azure SQL',
  MICROSOFTAZUREBLOBSTORAGE: 'Microsoft Azure Blob Storage',
  MICROSOFTONEDRIVE: 'Microsoft OneDrive',
  MICROSOFTSQLSERVER: 'Microsoft SQL Server',
  MYSQL: 'MySQL',
  PGSQL: 'PgSQL',
  REDSHIFT: 'Amazon Redshift',
  SFTP: 'SFTP',
  SOQL: 'Salesforce SOQL',
  SOQL_CLIENT_CREDENTIALS: 'Salesforce SOQL (Client Credentials)',
  SOQL_TYPES: ['Salesforce SOQL', 'Salesforce SOQL (Client Credentials)'],
  SNOWFLAKE: 'Snowflake',
  SNOWFLAKE_LIVE: 'Snowflake (Live)',
  TAPAPI: 'TapAPI',
  QUICKBOOKSONLINE: 'QuickBooks Online',
  TAPDIRECT: 'TapDirect',
};

export const DefaultPreprocessFunction = {
  selected: '',
  url: '',
  custom_fields: [],
  is_custom: false,
};

export const SupportedDataTypes = [
  ColumnFormat.FORMAT_STRING,
  ColumnFormat.FORMAT_LINK,
  ColumnFormat.FORMAT_CLICK_TO_VIEW_LINK,
  ColumnFormat.FORMAT_PHONE_NUMBER,
  ImportWizardConstants.EXTRA_FORMAT_STRING_ID,
];

// data types white list:
export const DataTypes = [
  ColumnFormat.FORMAT_INTEGER,
  ColumnFormat.FORMAT_DECIMAL,
  ColumnFormat.FORMAT_PERCENT,
  ColumnFormat.FORMAT_CURRENCY,
  ColumnFormat.FORMAT_STRING,
  ColumnFormat.FORMAT_DATE,
  ColumnFormat.FORMAT_DATETIME,
  ColumnFormat.FORMAT_TIME,
  ColumnFormat.FORMAT_LINK,
  ColumnFormat.FORMAT_AUDIO,
  ColumnFormat.FORMAT_THUMBNAIL,
  ColumnFormat.FORMAT_PREVIEW,
  ColumnFormat.FORMAT_CLICK_TO_VIEW_LINK,
  ColumnFormat.FORMAT_PHONE_NUMBER,
  ColumnFormat.FORMAT_RANKING,
  ImportWizardConstants.EXTRA_FORMAT_INTEGER_BIG,
  ImportWizardConstants.EXTRA_FORMAT_STRING_ID,
];

// parent fields type that can be exposed - white list:
export const ParentDataTypes = [
  ColumnFormat.FORMAT_STRING,
  ColumnFormat.FORMAT_LINK,
  ColumnFormat.FORMAT_AUDIO,
  ColumnFormat.FORMAT_THUMBNAIL,
  ColumnFormat.FORMAT_PREVIEW,
  ColumnFormat.FORMAT_DATE,
  ColumnFormat.FORMAT_DATETIME,
  ColumnFormat.FORMAT_CLICK_TO_VIEW_LINK,
  ColumnFormat.FORMAT_PHONE_NUMBER,
  ColumnFormat.FORMAT_RANKING,
  ImportWizardConstants.EXTRA_FORMAT_STRING_ID,
];

export const isVirtualColumnHeaders = [
  ImportWizardConstants.SC_VIRTUAL_MAPPING,
  ImportWizardConstants.SC_TAB_MAPPING,
];

export const DEFAULT_GEO_STATE_FIELD = {
  location_type: 'state',
  field_name: '',
  pin_longitude_field_name: '',
  pin_latitude_field_name: '',
};

export const DEFAULT_GEO_COUNTRY_FIELD = {
  location_type: 'country',
  mode: ImportWizardConstants.GEO_COUNTRY_FIELD_MODE.COUNTRY_IN_DATA,
  field_name: '',
  field_value: '',
  pin_longitude_field_name: '',
  pin_latitude_field_name: '',
};

export const GeoLocationType = {
  COUNTRY: 'country',
  STATE: 'state',
  CITY: 'city',
  COUNTY: 'county',
  CONGRESSIONAL_DISTRICT: 'congressional_district',
  ZIP: 'zip',
  PIN: 'pin',
  DMA: 'dma',
};

export const DEFAULT_TAPDIRECT = {
  authorization: 'none',
  authorization_type: {
    none: '',
    oauth2: {
      header: 'Bearer ',
      grant_type: 'authorization_code',
      callback_url: 'https://im.tapclicks.com/oauthredirector.php',
      auth_url: '',
      access_token_url: '',
      client_id: '',
      client_secret: '',
      scope: '',
      state: 1,
      use_pkce: 0,
      client_authentication: 'basic',
    },
    basic: {
      username: '',
      password: '',
    },
    bearer_token: {
      token: '',
    },
  },
  method: 'GET',
  url: '',
  headers: [],
  params: [],
  body: 'none',
  body_type: {
    none: '',
    form_data: [],
    x_www_form_urlencoded: [],
    raw: '',
  },
  environment_variables: [],
  environment_variables_global: [],
  environment_variables_house: [
    { key: 'starting_date', value: 'yyyy-mm-dd' },
    { key: 'ending_date', value: 'yyyy-mm-dd' },
    { key: 'starting_offset', value: '0' },
    { key: 'increment_offset_by', value: '1' },
  ],
  sample_load: 'dynamic',
  fetch_sample_days: 3,
  pagination: 'none',
  pagination_type: {
    none: '',
    incremental: {},
    nextpageurl: {
      prefix: '',
      json_path: '',
    },
  },
  quick_mapping: [],
  extra_calls: [],
};

export const DEFAULT_TAPDIRECT_EXTRA_CALLS = {
  position: 0,
  show: true,
  method: 'GET',
  url: '',
  headers: [],
  params: [],
  body: 'none',
  body_type: {
    none: '',
    form_data: [],
    x_www_form_urlencoded: [],
    raw: '',
  },
  pagination: 'none',
  pagination_type: {
    none: '',
    incremental: {},
    nextpageurl: {
      prefix: '',
      json_path: '',
    },
  },
  environment_variables_house: [
    { key: 'mapping_starting_offset', value: '0' },
    { key: 'mapping_increment_offset_by', value: '1' },
  ],
  mapping_path: '',
  mapping_path_label: '',
  last_available_paths: [],
};

export const TapDirectAuthorizationType = {
  NONE: 'none',
  BASIC: 'basic',
  BEARER_TOKEN: 'bearer_token',
  OAUTH2: 'oauth2',
};

export const TapDirectGrantType = {
  AUTHORIZATION_CODE: 'authorization_code',
  CLIENT_CREDENTIALS: 'client_credentials',
};

export const SnowFlakeAuthType = {
  PASSWORD_AUTH: 'PASSWORD_AUTH',
  SECRET_KEY_AUTH: 'SECRET_KEY_AUTH',
};

export const SFTPAuthType = {
  PASSWORD_AUTH: 'PASSWORD_AUTH',
  KEY_AUTH: 'KEY_AUTH',
};

export const HttpMethod = {
  GET: 'GET',
  POST: 'POST',
};

export const TapDirectBodyType = {
  NONE: 'none',
  FORM_DATA: 'form_data',
  RAW: 'raw',
};

export const TapDirectPagination = {
  NONE: 'none',
  INCREMENTAL: 'incremental',
  NEXT_PAGE_URL: 'nextpageurl',
};

export const TapDirectSampleLoad = {
  DYNAMIC: 'dynamic',
  MANUAL: 'manual',
};

export const DEFAULT_AUTH_SYSTEM = {
  storage_account: '',
  container: '',
  protocol: 'TCPIP',
  host: '',
  server: '',
  database: '',
  character_set: 'utf8',
  port: '',
  username: '',
  password: '',
  // Amazon S3
  access_key_id: '',
  secret_access_key: '',
  bucket: '',
  // Athena
  catalog: '',
  output_location: '',
  sublevel: false,
  // Snowflake
  account: '',
  authentication_type: SnowFlakeAuthType.PASSWORD_AUTH,
  // Google BigQuery
  project: '',
  // Google BigQuery (Live)
  service_account: '',
  dataset: '',
  table: '',
  // Snowflake (Live)
  warehouse: '',
  schema: '',
  // Salesforce SOQL (Client Credentials)
  client_id: '',
  client_secret: '',
  login_url: '',
};
